var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg6 = function Svg6(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4E5969",
    fillRule: "evenodd",
    d: "M19.5 2.25h-15A2.25 2.25 0 0 0 2.25 4.5v15a2.25 2.25 0 0 0 2.25 2.25h15a2.25 2.25 0 0 0 2.25-2.25v-15a2.25 2.25 0 0 0-2.25-2.25m-15 1.5a.75.75 0 0 0-.75.75v6.75h7.5v-7.5zm6.75 9h-7.5v6.75c0 .414.336.75.75.75h6.75zm1.5 0h7.5v6.75a.75.75 0 0 1-.75.75h-6.75zm7.5-1.5h-7.5v-7.5h6.75a.75.75 0 0 1 .75.75z",
    clipRule: "evenodd"
  })));
};
export default Svg6;